<button
  mat-icon-button
  [color]="hasFilters() ? 'primary' : ''"
  [matMenuTriggerFor]="ordreFilter"
  matTooltip="Brug filtre"
  [matBadge]="filterCount()"
  matBadgeSize="small"
  [matBadgeHidden]="filterCount() === 0"
  [disabled]="isLoading"
  >
  <mat-icon svgIcon="filter"></mat-icon>
</button>

<mat-menu #ordreFilter="matMenu">
  @if (hasFilters()) {
    <button (click)="reset()" title="Fjern alle filtre" class="btn-icon red">
      <mat-icon svgIcon="delete"></mat-icon>
      <span>Fjern alle filtre</span>
    </button>
    <hr />
  }
  <div (click)="$event.stopPropagation()">
    <app-partner-filter [partners]="partners" [filter]="filter" (partnerChange)="onPartnerChange($event)"></app-partner-filter>
  </div>
</mat-menu>
